import {
    GET_LIST_BANK_REQUEST,
    GET_LIST_BANK_SUCCESS,
    GET_LIST_BANK_FAILED
} from '../../actionTypes'

const initialState = {
    data:[],
    error: '',
    isLoading: false
}

const listBankReducer = (state = initialState, action) =>{
    switch (action.type) {
        case GET_LIST_BANK_REQUEST:
            return {
                ...state,
                isLoading:true,
            }
        case GET_LIST_BANK_SUCCESS:
            return {
                ...state,
                isLoading:false,
                data: action.payload
            }
        case GET_LIST_BANK_FAILED:
            return {
                ...state,
                isLoading:false,
                error: action.error
            }
    
        default:
            return state;
    }
}

export default listBankReducer;